import {instance} from '../index';

export const periodsApi = {
  getPeriods () {
    return instance.get('periods')
  },
}
